import React from 'react';

export function HistoryNotFound() {
  return (
    <p className="mb-4 mt-4 text-center">
      Não há histórico de conversas para este cliente...
    </p>
  );
}
